import { render, staticRenderFns } from "./CameraPermissionModal.vue?vue&type=template&id=ed41628e"
import script from "./CameraPermissionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CameraPermissionModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CameraPermissionModal.vue?vue&type=style&index=0&id=ed41628e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports